// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgeEmailApi = class EdgeEmailApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param IsUnsubscribedRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async emailIsUnsubscribed(IsUnsubscribedRequestModel, x_program_id) {
        const _url_ = '/edge/email/IsUnsubscribed';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'IsUnsubscribedRequestModel' is not null or undefined
        if (IsUnsubscribedRequestModel === null || IsUnsubscribedRequestModel === undefined) {
            throw new Error('Required parameter IsUnsubscribedRequestModel was null or undefined when calling emailIsUnsubscribed.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(IsUnsubscribedRequestModel, "IsUnsubscribedRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EmailIsUnsubscribedDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param SendRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async emailSend(SendRequestModel, x_program_id) {
        const _url_ = '/edge/email/Send';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'SendRequestModel' is not null or undefined
        if (SendRequestModel === null || SendRequestModel === undefined) {
            throw new Error('Required parameter SendRequestModel was null or undefined when calling emailSend.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(SendRequestModel, "SendRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EmailSendDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param UnsubscribeRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async emailUnsubscribe(UnsubscribeRequestModel, x_program_id) {
        const _url_ = '/edge/email/Unsubscribe';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'UnsubscribeRequestModel' is not null or undefined
        if (UnsubscribeRequestModel === null || UnsubscribeRequestModel === undefined) {
            throw new Error('Required parameter UnsubscribeRequestModel was null or undefined when calling emailUnsubscribe.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(UnsubscribeRequestModel, "UnsubscribeRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EmailUnsubscribeDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param UnsubscribeBySourceNameRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async unsubscribeUnsubscribeBySourceName(UnsubscribeBySourceNameRequestModel, x_program_id) {
        const _url_ = '/edge/email/v2/Unsubscribe/unsubscribeBySourceName';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'UnsubscribeBySourceNameRequestModel' is not null or undefined
        if (UnsubscribeBySourceNameRequestModel === null || UnsubscribeBySourceNameRequestModel === undefined) {
            throw new Error('Required parameter UnsubscribeBySourceNameRequestModel was null or undefined when calling unsubscribeUnsubscribeBySourceName.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(UnsubscribeBySourceNameRequestModel, "UnsubscribeBySourceNameRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
};
EdgeEmailApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgeEmailApi);
export { EdgeEmailApi };
//# sourceMappingURL=edgeEmailApi.js.map